<template>

  <div>
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>
    </div>
 
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">The page you are looking for was not found.</p>
        </div>

        <CInput type="text" v-model="query" @keydown.enter="search" placeholder="Search..." />
        <!-- <CInput
          class="mb-3"
          placeholder="What are you looking for?"
        >
          <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
          <template #append>
            <CButton color="info">Search</CButton>
          </template>
        </CInput> -->
      </div>
      </CCol>
    </CRow>
  </CContainer>
  <Footerlayout></Footerlayout>
</div>
</template>
      
<script>
import Vue from "vue";
import Footerlayout from "../../containers/TheFooter.vue";


// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
      query: '',
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {

    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  name: "Login",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
      query: ''
    };
  },
  created() {
    AOS.init();

  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  async mounted() {
    // this.GetBlog();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
   
  },

  methods: {
    search() {
      if (this.query) {
        this.$router.push({ name: 'search', params: { query: this.query } });
      }
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
  },
};
</script>
          <<style scoped>
      
      @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
      @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
          
      .c-header {
        /* background: rgb(23, 77, 124);
        background: linear-gradient(92deg, #174d7c, #1b7682);
        border-bottom: 0.01px solid #1a6783;
        border-bottom: 1px solid #636f83; */
      
        background: transparent;
        border-bottom: 0;
        border-bottom: 0;
        /* color: #fff; */
      }
      .c-app{
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        font-family: 'Montserrat', sans-serif;
      }
      body {
        font-family: "Montserrat", sans-serif;
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      }
      h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
          margin-bottom: 0.5rem;
          font-weight: 500;
          line-height: 1.2;
          font-family: "Montserrat", sans-serif;
      }
      label
      {
        font-family: "Montserrat", sans-serif;
      }
      
      body nav.onScroll {
        box-shadow: 0 0 10px #aaa;
        background-color: rgb(255, 255, 255);
        font-family: 'Montserrat';
      font-style: normal;
      }
      body nav.onScroll ul li {
        color: #10b761;
      }
      body nav ul {
        margin-left: 3em;
        width: 25%;
        display: flex;
        justify-content: space-between;
      }
      body nav ul li {
        cursor: pointer;
        font-weight: 600;
        list-style-type: none;
        color: white;
      }
      body {
          top: 0 !important;
          font-family: 'Montserrat', sans-serif;
      }
    
      
       </style>